import { render, staticRenderFns } from "./AddMain.vue?vue&type=template&id=beb9c9e4&scoped=true&"
import script from "./AddMain.vue?vue&type=script&lang=js&"
export * from "./AddMain.vue?vue&type=script&lang=js&"
import style0 from "./AddMain.vue?vue&type=style&index=0&id=beb9c9e4&lang=scss&"
import style1 from "./AddMain.vue?vue&type=style&index=1&id=beb9c9e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb9c9e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('beb9c9e4')) {
      api.createRecord('beb9c9e4', component.options)
    } else {
      api.reload('beb9c9e4', component.options)
    }
    module.hot.accept("./AddMain.vue?vue&type=template&id=beb9c9e4&scoped=true&", function () {
      api.rerender('beb9c9e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchaseorder/AddMain.vue"
export default component.exports